var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInicio = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Inici") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inici/Menu-Obert",
  transform: "translate(-31.000000, -101.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inici",
  transform: "translate(0.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.7781221,24.3284024 L38.3032331,18.1213018 C38.1336198,17.9595661 37.8663802,17.9595661 37.697753,18.1213018 L31.2159611,24.3353057 C31.0788899,24.4723866 31,24.6617357 31,24.8540434 C31,25.2554241 31.3273931,25.5828402 31.7297316,25.5828402 L32.7503698,25.5828402 L32.7503698,31.1262327 C32.7503698,31.6084813 33.141861,32 33.6250616,32 L36.1041769,32 C36.3457773,32 36.5420159,31.8047337 36.5420159,31.5631164 L36.5420159,28.3185404 C36.5420159,28.2386588 36.6071001,28.1715976 36.6879622,28.1715976 L39.3130239,28.1715976 C39.3928999,28.1715976 39.4579841,28.2386588 39.4579841,28.3185404 L39.4579841,31.5631164 C39.4579841,31.8047337 39.6542227,32 39.8958231,32 L42.3749384,32 C42.858139,32 43.2506163,31.6084813 43.2506163,31.1262327 L43.2506163,25.5828402 L44.2712545,25.5828402 C44.673593,25.5828402 45,25.2554241 45,24.8540434 C45,24.6617357 44.9220962,24.4723866 44.7781221,24.3284024",
  id: "Icon-Inicio"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInicio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_inicio.309f7cff5b8511626b1e9173cee2a086.svg";